import { datadogLogs, LogsEvent } from '@datadog/browser-logs';
import { AxiosError } from 'axios';
import { pick } from 'lodash-es';

const loggerForType =
  (type: 'info' | 'error' | 'warn' | 'debug') =>
  (message: string, options?: any): void => {
    if (process.env.NODE_ENV === 'production') {
      datadogLogs.logger[type](message, options);
    } else {
      console[type](message, options);
    }
  };

export function initialise(): void {
  datadogLogs.init({
    site: 'datadoghq.com',
    version: process.env.REACT_APP_RELEASE_VERSION?.trim(),
    service: 'react-covid-travel',
    sampleRate: 100,
    env: process.env.REACT_APP_DEPLOY_ENV?.trim(),
    clientToken: process.env.REACT_APP_DATA_DOG_TOKEN || '',
    forwardErrorsToLogs: true,
    beforeSend: log => {
      if (log.isAxiosError) {
        // suppress user data from the axios config object. Else the JWT & PII is logged
        (log as AxiosError & LogsEvent).config = pick(
          (log as AxiosError & LogsEvent).config,
          'url',
          'baseURL',
          'method'
        );
      }
      if (log.view.referrer) {
        log.view.referrer = log.view.referrer.replace(
          /resume_key=([^&]*)/,
          'resume_key=<REDACTED>'
        );
      }
    }
  });
}

export const logger = {
  info: loggerForType('info'),
  debug: loggerForType('debug'),
  error: loggerForType('error'),
  warn: loggerForType('warn'),
  setContext: datadogLogs.addLoggerGlobalContext
};

export default logger;
